import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { parseDecimal } from '../../../../../libs/utils'
import {
  BudgetItem,
  BudgetItemResponse,
  BudgetPaymentForm,
} from './types'
import { $params } from '../../../../../features/router'
import { initialBudgetModalState } from './const'

const buildBody = (data: BudgetPaymentForm, walletOverride?: string) => ({
  wallet: walletOverride || data.walletId,
  walletId: '',
  budgetItem: data.budgetItemId,
  budgetItemId: data.budgetItemId,
  product: data.product,
  recipient: data.recipient,
  amount: parseDecimal(data.amount),
  currency: data.currency,
  commission: parseDecimal(data.commission),
  commissionCurrency: data.commissionCurrency,
  exchangeRate: parseDecimal(data.exchangeRate),
  comment: data.comment,
  dateTime: data.dateTime,
})

export const budgetItemsMounted = createEvent()

export const addBudgetPaymentMounted = createEvent<BudgetPaymentForm>()

export const getBudgetPaymentByIdMounted = createEvent<{ id: string }>()

export const editBudgetPaymentMounted = createEvent<BudgetPaymentForm>()

export const setBudgetPaymentForm = createEvent<BudgetPaymentForm>()

export const deleteBudgetPaymentMounted = createEvent<{ id: string }>()

export const $budgetPaymentForm = restore(
  setBudgetPaymentForm,
  initialBudgetModalState,
)

export const getBudgetItem = fx<void, BudgetItemResponse>({
  method: 'GET',
  url: `/finance/budget_item`,
})

export const addBudgetPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'POST',
  url: `/finance/budget_payment`,
})

export const editBudgetPayment = fx<ReturnType<typeof buildBody>, void>({
  method: 'PUT',
  url: `/finance/budget_payment/{id}`,
})

export const getBudgetPaymentById = fx<{ id: string }, BudgetPaymentForm>({
  method: 'GET',
  url: `/finance/budget_payment/{id}`,
})

export const deleteBudgetPayment = fx<BudgetPaymentForm, void>({
  method: 'DELETE',
  url: `/finance/budget_payment/{id}`,
})

export const $budgetItems = restore<BudgetItem[]>(
  getBudgetItem.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: budgetItemsMounted,
  fn: () => ({}),
  target: getBudgetItem,
})

sample({
  clock: addBudgetPaymentMounted,
  source: $params,
  fn: (params, data) => ({
    body: buildBody(data, params?.walletID),
  }),
  target: addBudgetPayment,
})

sample({
  clock: editBudgetPaymentMounted,
  fn: (data) => ({
    url: `/finance/budget_payment/${data.id}`,
    body: buildBody(data),
  }),
  target: editBudgetPayment,
})

sample({
  clock: getBudgetPaymentByIdMounted,
  fn: ({ id }) => ({ url: `/finance/budget_payment/${id}` }),
  target: getBudgetPaymentById,
})

sample({
  clock: deleteBudgetPaymentMounted,
  fn: ({ id }) => ({ url: `/finance/budget_payment/${id}` }),
  target: deleteBudgetPayment,
})

sample({
  clock: getBudgetPaymentById.doneData,
  fn: (doneData) => doneData.body,
  target: setBudgetPaymentForm,
})
